// extracted by mini-css-extract-plugin
export default {"metrics_pm":"MemorandumValues_metrics_pm__xArx1","column_metrics":"MemorandumValues_column_metrics__nucHm"};